var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M3.52.19l22.627 22.628-2.829 2.829L.691 3.019z","key":0}),React.createElement("path",{"d":"M.69 22.98L23.319.354l2.829 2.829L3.519 25.809z","key":1})]));
}

IconClose.defaultProps = {"width":"27","height":"26","viewBox":"0 0 27 26"};

module.exports = IconClose;

IconClose.default = IconClose;
